export default __webpack_public_path__ + "static/media/welcome.9f8bf3f3.png";